import type { Role } from '@aeris/permissions'

/**
 * Role names and explanations, for people rather than for code.
 *
 * `@aeris/permissions` is the machine-readable catalogue and is deliberately
 * free of Portuguese and of any UI concern (ADR-0013). This is the translation,
 * and it lives in the web app for the same reason.
 *
 * The descriptions are the short version of the permission table in
 * `catalogue.ts`. If that table changes, these sentences are what has to change
 * with it — which is why they say what a role *does* rather than listing
 * permission strings nobody outside the code recognises.
 */

export const ROLE_LABELS: Record<Role, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  manager: 'Gerente',
  cashier: 'Caixa',
  trocador: 'Trocador',
  salesperson: 'Vendedor',
}

/**
 * O que cada um faz — e, nos dois do balcão, o que ele NÃO faz.
 *
 * Quem escolhe o papel de alguém está decidindo quanto dinheiro aquela pessoa
 * pode tocar, e essa frase é toda a ajuda que ela tem na hora.
 */
export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  owner: 'Acesso total, incluindo a equipe e a organização.',
  admin: 'Igual ao proprietário no dia a dia, e também administra a equipe.',
  manager: 'Cuida do catálogo, dos preços, do estoque e das vendas.',
  cashier:
    'Recebe: conclui a venda, abre a gaveta e acerta com o motoboy. Não altera o preço que o cliente já aceitou.',
  trocador:
    'Faz a troca e emite o vale. A peça devolvida é defeito e não volta ao estoque, e na troca o cliente leva no máximo o que devolveu. Não recebe dinheiro: a diferença que o cliente deve, o caixa recebe.',
  salesperson:
    'Atende e faz o orçamento, que segura a mercadoria. Não recebe dinheiro nem conclui a venda.',
}
